import * as React from 'react';
import { useEffect } from 'react';
import type { DepartureCheck } from './models/DriverJobInterfaces';

interface DriverJobsDepartOfficeProps {
    truckId: number;
    departureCheck: DepartureCheck;
    saveDisabled: boolean;
    updateDetails(fieldName: string, fieldValue: number): void;
    save(): void;
}

const DriverJobsDepartOfficeData = (props: DriverJobsDepartOfficeProps) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errorList = errors;
        if (e.target.value) {
            delete errorList[e.target.name];
            setErrors(errorList);
        }

        var value = e.target.value * 1;
        props.updateDetails(e.target.name, value);
    }

    const validate = () => {
        let fields = props.departureCheck;
        let errorList: any = {};
        let formIsValid = true;

        if (!fields.gearCheck || fields.gearCheck < 1) {
            formIsValid = false;
            errorList["gearCheck"] = "You MUST complete gear check before departing!";
        }

        if (!fields.teamMemberPpe || fields.teamMemberPpe < 0) {
            formIsValid = false;
            errorList["teamMemberPpe"] = "Team Members PPE is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            props.save();
        }
    }

    return (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <h4>Departure Checks</h4>
                <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="gearCheck">
                    <span className="label-mobile--inline margin5">Have you completed the gear check?</span>
                    <input type="radio" id="yes" name="gearCheck" value={1} checked={props.departureCheck.gearCheck === 1} onChange={(e) => handleChange(e)}></input>
                    <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                    <input type="radio" id="no" name="gearCheck" value={0} checked={props.departureCheck.gearCheck === 0} onChange={(e) => handleChange(e)}></input>
                    <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                </label>
                <span className={errors["gearCheck"] ? "label errors" : "hidden"}>{errors["gearCheck"]}</span>

                <label className="input-group makeitflexspacebetween alignitemscentre truckcheck-background" htmlFor="teamMemberPpe">
                    <span className="label-mobile--inline margin5">Are all team members wearing appropriate PPE, i.e. Hard Hat, Hi Vis Clothing, Boots etc?</span>
                    <input type="radio" id="yes" name="teamMemberPpe" value={1} checked={props.departureCheck.teamMemberPpe === 1} onChange={(e) => handleChange(e)}></input>
                    <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>
                    <input type="radio" id="no" name="teamMemberPpe" value={0} checked={props.departureCheck.teamMemberPpe === 0} onChange={(e) => handleChange(e)}></input>
                    <span className="makeitflex makeitcentervertical marginLeft10">No</span>
                </label>
                <span className={errors["teamMemberPpe"] ? "label errors" : "hidden"}>{errors["teamMemberPpe"]}</span>
                <span className={props.departureCheck.teamMemberPpe === 0 ? "label errors" : "hidden"}>Please call your supervisor for instructions.</span>

                <div className="defaultbutton__container--right marginTop10">
                    <i className={"mobile-icon-green fas fa-circle-check mobileMenuSize" + (props.saveDisabled ? " mobile-image-button--disabled" : "" )} onClick={(e) => save(e)}></i>
                </div>

            </div>
        </div>
    );
}

export default DriverJobsDepartOfficeData;